import type { App } from 'vue'
import { ElMessage, ElMessageBox, ElNotification, ID_INJECTION_KEY, ZINDEX_INJECTION_KEY } from 'element-plus'

export default {
  install: (Vue: App) => {
    Vue.provide(ID_INJECTION_KEY, {
      prefix: Math.floor(Math.random() * 10000),
      current: 0
    })
    Vue.provide(ZINDEX_INJECTION_KEY, { current: 0 })
    const globalProperties = Vue.config.globalProperties
    globalProperties.$message = ElMessage
    globalProperties.$messageBox = ElMessageBox
    globalProperties.$notify = ElNotification
  }
}
